import { useAuth0 } from "@auth0/auth0-react";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import ExportSvgComponent from "assets/icons/svg/exportFilter";
import PrintSvgComponent from "assets/icons/svg/print";
import AutoCompleteField from "components/autoCompleteField";
import { AsyncAutoCompleteField } from "components/autoCompleteField/AsyncAutoField";
import MyFilterButton from "components/MyFilterButton";
import { useSearch } from "hook";
import FinanceService from "Lib/API/Finance";
import MemberService from "Lib/API/Member";
import moment from "moment";
import React, { useEffect, useState } from "react";
import CsvDownloader from "react-csv-downloader";
import { useSelector } from "react-redux";
import { sanitizeRows } from "utils/exportSanitize";
import DateRange from "../../payments/paymentsRequest/dateRangeComponent";
import { DateFormetContext } from "../../../../app/App.js";
import { toastr } from "react-redux-toastr";

const InvoicesFilter = ({
  selectionModel,
  list,
  setLoading,
  selected,
  status,
  ...props
}) => {
  const dateFormet = React.useContext(DateFormetContext);
  const [open, setOpen] = React.useState(false);
  const [size, setSize] = useState(5);
  const [search, setSearch] = useState(undefined);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setMembersLoading] = useState(false);
  const [filter, setFilter] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [contactsList, setContactsList] = React.useState([]);
  const { searchAction } = useSearch({ action: setSearch });
  const { contacts, products } = useSelector((state) => state?.data);
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    async function fetchMyAPI() {
      setMembersLoading(true);
      const token = await getAccessTokenSilently();
      await MemberService.getContacts(token, search).then((res) => {
        if (res?.contacts) {
          res.contacts.map((item) => {
            item.id = item.member_id;
            item.label = item?.first_name + " " + item?.last_name;
            item.value = item._id;
            return item;
          });
          setContactsList(res?.contacts);
        }
        setMembersLoading(false);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
    }
    fetchMyAPI();
  }, [search]);
  const style = {
    width: "200px",
    height: "45px",
    border: "none",
    borderRadius: "5px",
    marginInlineEnd: "10px",
  };

  useEffect(() => {
    setLoading(true);
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      const input = {
        filter: {
          member_id: props.memberId?.value,
          product_id: props.productId?.value,
          from_date: startDate,
          to_date: endDate,
        },
      };
      if (filterStatus !== "all") input.filter.status = filterStatus;

      FinanceService.getInvoices(input, props.FPage, size, token)
        .then((res) => {
          if (res?.invoices) {
            res.invoices.map((item) => {
              item.id = item._id;
              return item;
            });
            props.setList(res.invoices);
            props.setTotal(res?.total);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }

    fetchMyAPI();
  }, [
    props.FPage,
    props.productId,
    props.memberId,
    filterStatus,
    filter,
    size,
  ]);

  const handleStatusChange = (value) => {
    setFilterStatus(value);
  };
  const columns = [
    {
      id: "inv_id",
      displayName: "ID",
    },
    {
      id: "inv_issue_date",
      displayName: "ISSUES DATE",
    },
    {
      id: "inv_due_date",
      displayName: "DUE DATE",
    },
    {
      id: "date_balance",
      displayName: "DATE BALANCE",
    },
    {
      id: "member_name",
      displayName: "MEMBER NAME",
    },
    {
      id: "total",
      displayName: "TOTAL",
    },
    {
      id: "status",
      displayName: "STATUS",
    },
  ];

  const getData = () => {
    const arr = [];
    list.forEach((item) => {
      const d = {
        inv_id: item?.inv_id,
        inv_issue_date: moment(item?.inv_issue_date)
          .utcOffset("+0100")
          .format(dateFormet),
        inv_due_date: moment(item?.inv_due_date)
          .utcOffset("+0100")
          .format(dateFormet),
        date_balance: moment(item?.inv_due_date).diff(
          moment(item?.inv_issue_date),
          "days"
        ),
        member_name: item?.memberDetails?.member_name,
        total: item?.payment_amount?.total,
        status:
          item.payment_amount?.payment_status === "UnPaid" ? "Open" : "Paid",
      };
      arr.push(d);
    });
    return arr;
  };

  return (
    <div className="activated-ledger">
      <div className="bar d-flex justify-content-between">
        <div className="sub-header-functions">
          <AsyncAutoCompleteField
            onInputChange={(text) => searchAction(text)}
            classNamePrefix="react-select"
            options={contactsList}
            className="w-250px mr-5"
            placeholder="Select a Member..."
            isLoading={loading}
            handleChange={props.setMemberId}
            value={props.memberId}
            style={{ background: "#ffff" }}
          />
          <AutoCompleteField
            style={style}
            classNamePrefix="react-select"
            options={products}
            placeholder="Product"
            value={props.productId}
            onChange={(value) => {
              props.setProductId(value);
            }}
          />

          <MyFilterButton
            type={"Show"}
            title="All"
            items={[
              { label: "All", value: "all" },
              { label: "Paid", value: "Paid" },
              { label: "Open", value: "UnPaid" },
            ]}
            onChange={handleStatusChange}
          />
          <DateRange
            setFilter={setFilter}
            endDate={endDate}
            startDate={startDate}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            open={open}
            setOpen={setOpen}
          />
          <button
            className="date-button"
            onClick={() => {
              setFilter(false);
              setOpen(true);
            }}
          >
            <span className="pl-2">Date Range</span>
            <CalendarTodayOutlinedIcon />
          </button>
        </div>
        <div className="options">
          <div className="svg-filters">
            <CsvDownloader
              filename="EazyTemple"
              extension=".csv"
              columns={columns}
              datas={sanitizeRows(getData())}
            >
              <ExportSvgComponent /> <span>Export</span>
            </CsvDownloader>
          </div>
          <div className="svg-filters" onClick={() => {}}>
            <PrintSvgComponent /> <span>Print</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicesFilter;
